import Vue from "vue";
import Router from "vue-router";
import Home from "./views/HomeView.vue";
import BancoCaso from "./components/BancoCasos.vue";
import ControlSocial from "./components/ControlSocial.vue";
import Curso from "./components/Curso.vue";
import Autodig from "./components/Autodig.vue";
import About from "./components/About.vue";
import DetalleCaso from "./components/DetalleCaso.vue";
import CasosTot from "./components/CasosTot.vue";
import CasosTotales from "@/components/Casos/CasosTotales.vue";


Vue.use(Router);

const router =  new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
        },
        {
            path: "/bancocaso",
            name: "bancocaso",
            component: BancoCaso,
        },
        {
            path: "/controlsocial",
            name: "controlsocial",
            component: ControlSocial,
        },
        {
            path: "/curso",
            name: "curso",
            component: Curso,
        },        
        {
            path: "/autodig",
            name: "autodig",
            component: Autodig,
        },
        {
            path: "/about/:id",
            name: "about",
            component: About,
        },
        {
            path: "/detallecaso/:id",
            name: "detallecaso",
            component: DetalleCaso,
        },
        {
            path: "/casostot",
            name: "casostot",
            component: CasosTot,
        },
        {
            path: "/casostotales",
            name: "casostotales",
            component: CasosTotales,
        },
    ],
});

export default router;